/* tslint:disable */
/* eslint-disable */
/**
 * Kinde Management API
 * Provides endpoints to manage your Kinde Businesses
 *
 * The version of the OpenAPI document: 1
 * Contact: support@kinde.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime.js';
import { CreateFeatureFlagRequestToJSON, SuccessResponseFromJSON, } from '../models/index.js';
/**
 *
 */
var FeatureFlagsApi = /** @class */ (function (_super) {
    __extends(FeatureFlagsApi, _super);
    function FeatureFlagsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create feature flag.
     * Create Feature Flag
     */
    FeatureFlagsApi.prototype.createFeatureFlagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createFeatureFlagRequest === null || requestParameters.createFeatureFlagRequest === undefined) {
                            throw new runtime.RequiredError('createFeatureFlagRequest', 'Required parameter requestParameters.createFeatureFlagRequest was null or undefined when calling createFeatureFlag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/feature_flags",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreateFeatureFlagRequestToJSON(requestParameters.createFeatureFlagRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create feature flag.
     * Create Feature Flag
     */
    FeatureFlagsApi.prototype.createFeatureFlag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createFeatureFlagRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete feature flag
     * Delete Feature Flag
     */
    FeatureFlagsApi.prototype.deleteFeatureFlagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.featureFlagKey === null || requestParameters.featureFlagKey === undefined) {
                            throw new runtime.RequiredError('featureFlagKey', 'Required parameter requestParameters.featureFlagKey was null or undefined when calling deleteFeatureFlag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/feature_flags/{feature_flag_key}".replace("{".concat("feature_flag_key", "}"), encodeURIComponent(String(requestParameters.featureFlagKey))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete feature flag
     * Delete Feature Flag
     */
    FeatureFlagsApi.prototype.deleteFeatureFlag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteFeatureFlagRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update feature flag.
     * Replace Feature Flag
     */
    FeatureFlagsApi.prototype.updateFeatureFlagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.featureFlagKey === null || requestParameters.featureFlagKey === undefined) {
                            throw new runtime.RequiredError('featureFlagKey', 'Required parameter requestParameters.featureFlagKey was null or undefined when calling updateFeatureFlag.');
                        }
                        if (requestParameters.name === null || requestParameters.name === undefined) {
                            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateFeatureFlag.');
                        }
                        if (requestParameters.description === null || requestParameters.description === undefined) {
                            throw new runtime.RequiredError('description', 'Required parameter requestParameters.description was null or undefined when calling updateFeatureFlag.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling updateFeatureFlag.');
                        }
                        if (requestParameters.allowOverrideLevel === null || requestParameters.allowOverrideLevel === undefined) {
                            throw new runtime.RequiredError('allowOverrideLevel', 'Required parameter requestParameters.allowOverrideLevel was null or undefined when calling updateFeatureFlag.');
                        }
                        if (requestParameters.defaultValue === null || requestParameters.defaultValue === undefined) {
                            throw new runtime.RequiredError('defaultValue', 'Required parameter requestParameters.defaultValue was null or undefined when calling updateFeatureFlag.');
                        }
                        queryParameters = {};
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.description !== undefined) {
                            queryParameters['description'] = requestParameters.description;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.allowOverrideLevel !== undefined) {
                            queryParameters['allow_override_level'] = requestParameters.allowOverrideLevel;
                        }
                        if (requestParameters.defaultValue !== undefined) {
                            queryParameters['default_value'] = requestParameters.defaultValue;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/feature_flags/{feature_flag_key}".replace("{".concat("feature_flag_key", "}"), encodeURIComponent(String(requestParameters.featureFlagKey))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update feature flag.
     * Replace Feature Flag
     */
    FeatureFlagsApi.prototype.updateFeatureFlag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateFeatureFlagRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return FeatureFlagsApi;
}(runtime.BaseAPI));
export { FeatureFlagsApi };
/**
 * @export
 */
export var UpdateFeatureFlagTypeEnum = {
    Str: 'str',
    Int: 'int',
    Bool: 'bool'
};
/**
 * @export
 */
export var UpdateFeatureFlagAllowOverrideLevelEnum = {
    Env: 'env',
    Org: 'org'
};
